import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=5a74b7dc&scoped=true&"
import script from "./AppContainer.vue?vue&type=script&lang=ts&"
export * from "./AppContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AppContainer.vue?vue&type=style&index=0&id=5a74b7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a74b7dc",
  null
  
)

export default component.exports